// Module
var code = `<div class="position-balance-panel">
    <div class="position-balance-panel-container-top" {{#if !.accountSelectorVisible}}style="display: none;"{{/if}}>
        <accountSelector name="accountSelector" selectedItem="{{account}}" isMultiSelectMode="true" visible="{{.accountSelectorVisible}}"/>
    </div>

    <div class="position-balance-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;